export default __webpack_public_path__ + "static/media/data-access.f64a2c23.svg";